@if (!isMobile) {
  <button
    [class.overlay]="isSharedView"
    icon-button
    (click)="openMenu()"
    >
    <gl-icon class="moreIcon" [name]="'more'"></gl-icon>
  </button>
}
@if (isMenuContainerOpen) {
  <div class="menuContainer" #menuContainer>
    <ul class="menu">
      <li (click)="deleteAllLoads()" class="menuItem"><gl-icon name="delete" class="menuIcon"></gl-icon> {{'delete_all_the_loads' | translate}}</li>
      @if (showAddLoads) {
        <li (click)="addLoadsToLoadingSpace()" class="menuItem"><gl-icon [name]="'add-1'"  class="menuIcon"></gl-icon> {{'add_loads_to_loading_space' | translate}}</li>
      }
    </ul>
  </div>
}
